import { render, staticRenderFns } from "./approvalConfigAdd.vue?vue&type=template&id=dcf4030a&scoped=true"
import script from "./approvalConfigAdd.vue?vue&type=script&lang=js"
export * from "./approvalConfigAdd.vue?vue&type=script&lang=js"
import style0 from "./approvalConfigAdd.vue?vue&type=style&index=0&id=dcf4030a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf4030a",
  null
  
)

export default component.exports